import React from 'react';
import { IconProps } from '../IconProps';
const SvgChat = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.001 1a8.011 8.011 0 00-7.075 4.258 7.974 7.974 0 00.235 7.872l-1.104 2.774a.8.8 0 001 1.054l3.011-1.014a8.01 8.01 0 0011.613-4.742 7.971 7.971 0 00-1.291-7.013A7.997 7.997 0 009.003 1H9z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgChat;
